export const environment = {
  production: false,
  apiBaseUrl: 'https://vtzm2o9e77.execute-api.eu-central-1.amazonaws.com',
  //apiBaseUrl: 'https://886e6z3ag6.execute-api.eu-central-1.amazonaws.com', // prod
};
